import { useCallback } from 'react';
import { useAuthStore } from '../stores/authStore';

export function useAuth() {
  const { user, isLoading, error, login, register, logout, clearError } = useAuthStore();

  const signIn = useCallback(async (email: string, password: string) => {
    await login(email, password);
  }, [login]);

  const signUp = useCallback(async (email: string, password: string, _name?: string) => {
    await register(email, password);
  }, [register]);

  const signOut = useCallback(async () => {
    await logout();
  }, [logout]);

  const resetPassword = useCallback(async (_email: string) => {
    // TODO: implement when backend endpoint is ready
    throw new Error('Password reset non ancora disponibile');
  }, []);

  return {
    user,
    session: null,
    loading: isLoading,
    error: error ? new Error(error) : null,
    isAuthenticated: !!user,
    signIn,
    signUp,
    signOut,
    resetPassword,
    clearError,
  };
}
